function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { addUniqueItem, removeItem } from './array.mjs';

var SubscriptionManager = /*#__PURE__*/function () {
  function SubscriptionManager() {
    _classCallCheck(this, SubscriptionManager);

    this.subscriptions = [];
  }

  _createClass(SubscriptionManager, [{
    key: "add",
    value: function add(handler) {
      var _this = this;

      addUniqueItem(this.subscriptions, handler);
      return function () {
        return removeItem(_this.subscriptions, handler);
      };
    }
  }, {
    key: "notify",
    value: function notify(a, b, c) {
      var numSubscriptions = this.subscriptions.length;
      if (!numSubscriptions) return;

      if (numSubscriptions === 1) {
        /**
         * If there's only a single handler we can just call it without invoking a loop.
         */
        this.subscriptions[0](a, b, c);
      } else {
        for (var i = 0; i < numSubscriptions; i++) {
          /**
           * Check whether the handler exists before firing as it's possible
           * the subscriptions were modified during this loop running.
           */
          var handler = this.subscriptions[i];
          handler && handler(a, b, c);
        }
      }
    }
  }, {
    key: "getSize",
    value: function getSize() {
      return this.subscriptions.length;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.subscriptions.length = 0;
    }
  }]);

  return SubscriptionManager;
}();

export { SubscriptionManager };